const LOCAL_STORAGE_KEY = {
    APPS: "apps",
    HOST: "host",
    SYSTEM: "system",
    MENU_STATUS: "menuStatus",
    SIDE_NAV_STATUS: "sideNavStatus",
    TABLE_COLUMNS: "tableColumns",
    TENANT_DATA: "tenantData",
    THEME_KEY: "themeKey",
    UI_VERSION: "uiVersion",
    VULNERABILITIES: "vulnerabilities",
    WS_DATA: "wsData",
    FORGE_ENABLED: "forgeEnabled",
};

export default LOCAL_STORAGE_KEY;
